import styled from 'styled-components';

import { Multiselect } from '@dreryk/react-components';

export const StyledEncounterModeMultiselect = styled(Multiselect)`
   width: 250px;
` as typeof Multiselect;
